import React, { Component } from "react";
import Internet from "../image/internet.jpeg"

class NetworkIssue extends Component{
    render(){
        return(
            <div className="Loading_error_container">
                {/* <div className="network_container"> */}
                <div className="image">
                  {/* <PiNetworkX /> */}
                  <img src={Internet} alt="internet"/>
                </div>
                <br />
                <h2>Something Went Wrong<br/> Reload page</h2>
              {/* </div> */}
            </div>
        )
    }
}


export default NetworkIssue